export const ACCESSIBILITY_BLOCK_LEAVING_DISMISS = "dismiss";
export const ACCESSIBILITY_BLOCK_LEAVING_DENIED = "denied";
export const ACCESSIBILITY_BLOCK_LEAVING_BLOCK = "block";

export type AccessibilityBlockLeavingType =
  | typeof ACCESSIBILITY_BLOCK_LEAVING_DISMISS
  | typeof ACCESSIBILITY_BLOCK_LEAVING_DENIED
  | typeof ACCESSIBILITY_BLOCK_LEAVING_BLOCK;
